import { StoreModelNames } from "../../dali/type/dali.type";
import { SourceBalanceStoreModel } from "../../../models/store/source-balance.store.model";
import { signal } from "@angular/core";
import { StoreModelCollection } from "@bitwarden/web-vault/app/services/store/model.collection.abstraction";
import { SourceBalancesView } from "@bitwarden/web-vault/app/models/view/source-balances/source-balances.view";

export class SourceBalancesStoreCollection extends StoreModelCollection {
  readonly type: StoreModelNames = "SourceBalanceStoreModel";
  protected models: Map<string, SourceBalanceStoreModel> = new Map<
    string,
    SourceBalanceStoreModel
  >();

  private _sourceBalanceViews = signal<SourceBalancesView[]>(null);
  readonly sourceBalanceViews = this._sourceBalanceViews.asReadonly();

  triggerChanges(): void {
    const views: SourceBalancesView[] = [];
    this.models.forEach((model) => {
      views.push(this.deepFreeze(new SourceBalancesView(model)));
    });
    this._sourceBalanceViews.set(views);
  }

  clear(): void {
    this.models.clear();
    this._sourceBalanceViews.set(null);
  }
}
